var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 206,
    viewBox: "0 0 206 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 103,
    r: 103,
    fill: "#2A2C30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieDark);
export default __webpack_public_path__ + "static/media/pie-dark.575c950874cfc80cb8684bf6838fa3d7.svg";
export { ForwardRef as ReactComponent };